import { mapRecordFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetOneResponse } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';
import {
  ICorporatePartCostListItem,
  IGetActiveOverlappingCostPayload,
  IRemoveCorporatePartCostPayload,
  IUpsertCorporatePartCostPayload,
} from 'corporate/types';

export const upsertCorporatePartCost = async (data: IUpsertCorporatePartCostPayload) =>
  partfinitiClient.postForm(
    '/corporate/parts/save-cost',
    { corporatePartCost: data },
    { includeNullValues: true }
  );

export const removeCorporatePartCost = async (data: IRemoveCorporatePartCostPayload) =>
  partfinitiClient.postForm('/corporate/parts/remove-cost', data);

export const getActiveOverlappingCost = async (
  payload: IGetActiveOverlappingCostPayload,
  signal?: AbortSignal
): Promise<GetOneResponse<ICorporatePartCostListItem>> => {
  const { data } = await partfinitiClient.get(
    `/corporate/parts/get-active-overlapping-cost?${getQueryStringToSnakeCase(
      { corporatePartCost: payload },
      { removeNullValues: true }
    )}`,
    signal
  );

  return mapRecordFromServer<ICorporatePartCostListItem>(data?.corporate_part_cost, true);
};
